import { Link } from "react-router-dom";
import { Heart, LogIn, Shield } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-xs text-ga-ink/60 mb-8 hover:text-ga-ink">
          <span>←</span> Voltar ao site
        </Link>

        <div className="bg-white rounded-3xl border border-border p-8 shadow-sm">
          <div className="w-12 h-12 rounded-2xl bg-ga-emerald/10 flex items-center justify-center mb-5">
            <Shield className="w-5 h-5 text-ga-emerald" />
          </div>
          <h1 className="font-display font-black text-2xl text-ga-ink">Painel administrativo</h1>
          <p className="text-sm text-ga-ink/60 mt-2 leading-relaxed">
            Acesso restrito a administradores autorizados do Instituto GA+. Entre com sua conta Google.
          </p>

          <button
            type="button"
            onClick={handleLogin}
            className="btn-primary w-full mt-6"
            data-testid="admin-login-btn"
          >
            <LogIn className="w-4 h-4" />
            Entrar com Google
          </button>

          <p className="text-[11px] text-ga-ink/50 mt-5 leading-relaxed">
            Apenas contas previamente autorizadas conseguem acessar. Em caso de dúvida, entre em contato com o administrador do Instituto.
          </p>
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 text-xs text-ga-ink/40">
          <Heart className="w-3 h-3" /> Instituto GA+
        </div>
      </div>
    </div>
  );
}
